<div class="col matrix">
  <!-- Dropdowns -->
  <div class="row center dropdowns padding all">
    <div class="col full-width padding all">
      <div class="custom margin sm bottom">Keyway</div>
      <mat-select class="padding all" [(ngModel)]="defaultKwyName" (selectionChange)="selectKeyway($event.value)">
        <mat-option *ngFor="let keyway of cylinderKeyways" [value]="keyway.name"> {{ keyway.name }} </mat-option>
      </mat-select>
    </div>
  </div>

  <!-- Key Bitting Array -->
  <app-kba-input-array [block]="matrix?.keyBitArray" [disabled]="true"> Key Bitting Array </app-kba-input-array>

  <!-- Sequence of Progression -->
  <app-kba-input-array [block]="[matrix?.sequenceOfProgression]" [disabled]="true">
    Sequence of Progression
  </app-kba-input-array>
</div>
